import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import '@/store/modules/permission';

Vue.config.productionTip = false

// import Meta from 'vue-meta'
// Vue.use(Meta)
// Vue.use(ElementUI)

//滚动条清零
router.afterEach((to,from,next) => {
  window.scrollTo(0,0);
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')




// router.beforeEach((to, from, next) => {
//   if(to.name === 'AfterSalesService' && from.name === 'RefundGoodsDetail'){
//     to.meta.keepAlive = true;  // 让 列表页 缓存，即不刷新
//     next();
//   }else if (to.name === 'AfterSalesService' && from.name === 'Mine') {
//     to.meta.keepAlive = true;  // 让 列表页 即不缓存，刷新
//     next();
//   }else {
//     next()
//   }
//
// })
